'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

var IconGithub = /*#__PURE__*/React__default.forwardRef(function (_a, ref) {
  var _b = _a.fill,
      fill = _b === void 0 ? "none" : _b,
      _c = _a.stroke,
      _d = _a.weight,
      props = _tslib.__rest(_a, ["fill", "stroke", "weight"]);

  return core.jsx("svg", _tslib.__assign({
    fill: fill,
    viewBox: "0 0 33 33",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 33px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 33px;\n      "])))
  }, props), core.jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.608.455C7.614.455.32 7.748.32 16.745c0 7.197 4.667 13.302 11.14 15.456.815.15 1.112-.353 1.112-.785 0-.386-.014-1.411-.022-2.77-4.531.984-5.487-2.184-5.487-2.184-.741-1.882-1.809-2.383-1.809-2.383-1.479-1.01.112-.99.112-.99 1.635.115 2.495 1.679 2.495 1.679 1.453 2.489 3.813 1.77 4.741 1.353.148-1.052.569-1.77 1.034-2.177-3.617-.411-7.42-1.809-7.42-8.051 0-1.778.635-3.233 1.677-4.371-.168-.412-.727-2.069.16-4.311 0 0 1.367-.438 4.479 1.67a15.602 15.602 0 0 1 4.078-.549 15.62 15.62 0 0 1 4.078.549c3.11-2.108 4.475-1.67 4.475-1.67.889 2.242.33 3.899.163 4.311C26.37 12.66 27 14.115 27 15.893c0 6.258-3.809 7.635-7.437 8.038.584.503 1.105 1.497 1.105 3.017 0 2.177-.02 3.934-.02 4.468 0 .436.294.943 1.12.784 6.468-2.159 11.131-8.26 11.131-15.455 0-8.997-7.294-16.29-16.291-16.29",
    clipRule: "evenodd"
  }));
});
var templateObject_1;
exports.IconGithub = IconGithub;